<template>
  <div>
    <DxDataGrid
      :columns="columns"
      :width="800"
      :data-source="dataSource"
      :show-borders="true"
      :allow-column-resizing="true"
      :search-panel="searchPanel"
      :showRowLines="true"
      :hover-state-enabled="true"
      :remote-operations="true"
      @cell-prepared="onCellPrepared"
      @cell-click="startEdit"
    >
      <DxFilterRow :visible="true" />
      <DxGroupPanel :visible="true" />
      <DxGrouping :auto-expand-all="false" />
      <DxPaging :page-size="10" />
      <DxPager
        :visible="true"
        
        :show-page-size-selector="false"
        :show-info="true"
        :show-navigation-buttons="true"
      />
    </DxDataGrid>


<UserRoleManagement v-if="this.routeDef == 'user-tenant-access-requests'|| 'tenant-admin-panels.susbscriptions' " :routeDef="this.routeDef" :slug="slug"    :columnDef="this.column" :parentRoute="this.routeDef"  ref="user-role-ref" >

</UserRoleManagement>


  </div>
</template>
<script>
import {
  DxDataGrid,
  DxColumn,
  DxEditing,
  DxPopup,
  DxLookup,
  DxForm,
  DxHeaderFilter,
  DxFilterRow,
  DxGrouping,
  DxGroupPanel,
  DxScrolling,
  DxPager,
  DxPaging,
} from "devextreme-vue/data-grid";
import CustomStore from "devextreme/data/custom_store";
import { DxItem } from "devextreme-vue/form";
import UserRoleManagement from '@include/forms/UserRoleManagement.vue'
import { DxTextArea } from "devextreme-vue/text-area";
function isNotEmpty(value) {
  return value !== undefined && value !== null && value !== "";
}
let mRoute;
let mSlug;
function setRoute(context) {
  mRoute = context.routeDef;
  mSlug = context.slug;

}
const store = new CustomStore({
  key: "id",
  load: function (loadOptions) {
    var parameters = {};

    if (loadOptions.sort) {
      parameters.order_column = loadOptions.sort[0].selector;
      if (loadOptions.sort[0].desc) parameters.order_direction = "asc";
    }
    parameters.group = JSON.stringify(loadOptions.group);
    parameters.filter = JSON.stringify(loadOptions.filter);
    parameters.skip = loadOptions.skip;
    parameters.take = loadOptions.take;
    parameters.page = (parameters.skip + parameters.take) / parameters.take;
    var config = {
      params: parameters,
    };

    //let listurl = "/" + mRoute + "/list";
    let listurl = route(mRoute + ".list",mSlug);

    let createurl = "/" + mRoute + "/create";

    return axios
      .get(listurl, config)
      .then((response) => { 
        return {
          data: response.data.results.data,
          totalCount: response.data.results.total,
        };
      })
      .catch(() => {
        throw "Data Loading Error";
      });
  },
});

// this instance
var ins = Object();

export default {
  props: {
    routeDef: String,
    headersDef: Array,
     slug:String,
  },
  components: {
    DxDataGrid,
    DxColumn,
    DxPaging,
    DxEditing,
    DxPopup,
    DxLookup,
    DxForm,
    DxItem,
    DxHeaderFilter,
    DxTextArea,
    DxFilterRow,
    DxGrouping,
    DxGroupPanel,
    DxScrolling,
    DxPager,
    DxPaging,
    UserRoleManagement
  },
  methods: {
    actinButtons(cellElement, cellInfo) {
      cellElement.append(
        "<a href='./" +
          this.routeDef +
          "/" +
          cellInfo.data.id +
          "/edit' class='action-btn-link'><i class='fas fa-pencil-alt'></i></a>&nbsp;&nbsp;"
      );
      cellElement.append(
        "<a href='./" +
          this.routeDef +
          "/" +
          cellInfo.data.id +
          "' class='action-btn-link'><i class='far fa-eye'></i></i></a>"
      );
    },
    setColumnDefs() {
      if (this.routeDef == "user-tenant-access-requests") {
        var columnDefs1 = [
          {
            type: "buttons",
            buttons: [
              {
                icon: "todo",
                onClick: function (e) {
                  
                 // this.user_id = e.row.data.user_id;
                  //this.request_type = e.row.data.type;
                  ins.showUserRoleManagement(e);
                },
              },
              {
                icon: "remove",
                onClick: function (e) {
                  console.log("Request Rejected");
                },
              },
            ],
          },
        ];
      }
    else  if (this.routeDef == "tenant-admin-panels.subscriptions") {
        var columnDefs1 = [
          {
            type: "buttons",
            buttons: [
              {
                icon: "link",
                onClick: function (e) {
                  
                 // this.user_id = e.row.data.user_id;
                  //this.request_type = e.row.data.type;
                  ins.showUserRoleManagement(e);
                },
              },
            ],
          },
        ];
      }
       
      
      else {
        var columnDefs1 = [];
      }

      let result = this.headersDef;


      let reformattedArray = result.map((obj) => {
        let rObj = {};
        rObj["dataField"] = obj.dataField;
        rObj["caption"] = obj.label;
        return rObj;
      });
      columnDefs1 = reformattedArray.concat(columnDefs1);
      return columnDefs1;
    },
    startEdit(e, i) { 
      if (e.columnIndex == 0) {
        // alert(e.data.name);
        //console.log(this.routeDef+"/"+e.data.id);
        // window.location.href = this.routeDef+"/"+e.data.id;
         this.$inertia.get(route(this.routeDef + ".show", e.data.id));
      }
    },
    onCellPrepared(e) {
      if (e.columnIndex == 0 && e.rowIndex >= 0) {
        var elem = e.cellElement;
        elem.style.setProperty("cursor", "pointer", "important");
        elem.style.setProperty("color", "blue");
      }
    },
    onCellHoverChanged(e) {
      if (e.columnIndex == 0 && e.rowIndex >= 0) {
        var elem = e.cellElement;
        elem.style.setProperty("cursor", "pointer", "important");
        if (e.eventType === "mouseover") {
          e.cellElement.style.color = "blue";
        } else {
          e.cellElement.style.color = "";
        }

        elem.style.setProperty("color", "green");
      }
    },
     showUserRoleManagement(e){
       let ab ="user-role-ref";
      this.$refs[ab].showRolePopUp();
      this.$refs[ab].setData(e);
    }


  },
  mounted() {
    setRoute(this);

    ins = this;
   
  },
  data() {
    return {
      dataSource: store,
      showBorders: true,
      showRowLines: true,
      remoteOperations: true,
     
      columns: this.setColumnDefs(),
      searchPanel: {
        visible: true,
        width: 240,
        placeholder: "Search...",
      },
    };
  },
  created(){
  }
};
</script>

<style>

</style>